import { useAPIQuery, DesignCollectionsDraftApi } from "melco-shared-logic";

export const useDesignCollectionReferences = (designCollectionId: string) => {
  return useAPIQuery(
    DesignCollectionsDraftApi,
    ["designCollectionReferences", designCollectionId],
    async (api) => api.designCollectionsReferences({ id: designCollectionId })
  );
};
